var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulIKonAg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 369.71 321.14",
    style: {
      enableBackground: "new 0 0 369.71 321.14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#6F52EA;stroke-width:1.1321;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.75,273.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.75,216.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367,183.4L298.57,8.74c-1.25-3.2-4.86-4.78-8.05-3.52L7.66,116.02c-2.51,0.98-4.03,3.42-3.94,5.97 c0.07-3.45,2.88-6.22,6.35-6.22h35.46l242.55-95.01l63.05,160.94l-31.19,12.22v14.6l43.54-17.06 C366.68,190.21,368.25,186.6,367,183.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.11,77.38c-0.76-1.92-2.93-2.89-4.87-2.13c-17.54,6.87-37.33-1.78-44.2-19.31 c-0.32-0.8-1.08-1.28-1.89-1.28c-0.24,0-0.5,0.05-0.74,0.14L86.75,115.77H124l113.94-44.63c10.51,14.79,28.76,22.42,46.75,19.39 l9.88,25.24h14.59L294.11,77.38z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.73,116.08H9.93c-3.43,0-6.21,2.78-6.21,6.21v187.59c0,3.43,2.78,6.21,6.21,6.21h303.79 c3.43,0,6.21-2.78,6.21-6.21V122.29C319.94,118.86,317.16,116.08,313.73,116.08z M305.77,302.52H17.88V129.66h287.89V302.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.31,172.15c-24.27,0-43.94,19.67-43.94,43.94s19.67,43.94,43.94,43.94c24.27,0,43.94-19.67,43.94-43.94 S186.58,172.15,162.31,172.15z M162.31,244.61c-15.75,0-28.52-12.77-28.52-28.52c0-15.75,12.77-28.52,28.52-28.52 c15.75,0,28.52,12.77,28.52,28.52C190.83,231.84,178.06,244.61,162.31,244.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.7,204.53c-6.39,0-11.56,5.18-11.56,11.56c0,6.39,5.18,11.56,11.56,11.56c6.39,0,11.56-5.18,11.56-11.56 C253.27,209.7,248.09,204.53,241.7,204.53z M241.7,219.56c-1.92,0-3.47-1.55-3.47-3.47c0-1.92,1.55-3.47,3.47-3.47 c1.92,0,3.47,1.55,3.47,3.47C245.17,218.01,243.62,219.56,241.7,219.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.5,204.53c-6.39,0-11.56,5.18-11.56,11.56c0,6.39,5.18,11.56,11.56,11.56c6.39,0,11.56-5.18,11.56-11.56 C95.06,209.7,89.88,204.53,83.5,204.53z M83.5,219.56c-1.92,0-3.47-1.55-3.47-3.47c0-1.92,1.55-3.47,3.47-3.47 c1.92,0,3.47,1.55,3.47,3.47C86.96,218.01,85.41,219.56,83.5,219.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.99,180.83L286.99,180.83c-18.84,0-34.11-15.27-34.11-34.11v0c0-1.12-0.91-2.02-2.02-2.02H69.76 c-0.4,0-0.72,0.32-0.72,0.72v0c-0.08,18.78-15.33,33.97-34.11,33.97h0c-1.12,0-2.02,0.9-2.02,2.02v69.95 c0,1.12,0.91,2.02,2.02,2.02c18.84,0,34.11,15.27,34.11,34.11h182.1c0.96,0,1.73-0.78,1.73-1.73c0-18.84,15.27-34.11,34.11-34.11 h0c2.08,0,3.76-1.68,3.76-3.76v-63.3C290.75,182.51,289.06,180.83,286.99,180.83z M277.16,239.08 c-17.75,3.73-31.89,17.36-36.38,34.82H80.66c-4.78-16.06-17.81-28.61-34.16-32.69v-49.67c16.52-4.14,29.68-16.94,34.32-33.26 h159.89c4.4,17.6,18.6,31.36,36.45,35.11V239.08z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulIKonAg);
export default __webpack_public_path__ + "static/media/PUL-iKON-Ag.aaeb332e055f6b92e8e2c53d03587630.svg";
export { ForwardRef as ReactComponent };